import React, { useEffect } from 'react'
import { useToggle } from 'react-use'
import { ViewDatasetDescription } from './ViewDatasetDescription'
import { EditDatasetDescription } from './EditDatasetDescription'

import Heading from 'uiKit/texts/Heading.js'

type DescriptionInfoProps = {
  datasetId: string
  updatedAt: number
  title?: string
  text?: string
  onChange: (text: string) => Promise<void>
}

export const DatasetInfo: React.FC<DescriptionInfoProps> = ({
  datasetId,
  title = '',
  text = '',
  updatedAt,
  onChange,
}) => {
  const [editForm, toggleEditForm] = useToggle(false)

  const handleOpenEditForm = () => {
    toggleEditForm(true)
  }

  const handleCloseEditForm = () => {
    toggleEditForm(false)
  }

  const handleSaveEditForm = async (text: string) => {
    try {
      await onChange(text)
      toggleEditForm(false)
    } catch (error) {
      throw error
    }
  }

  useEffect(() => {
    handleCloseEditForm()
  }, [datasetId])

  return (
    <div>
      <Heading>{title}</Heading>

      {editForm ? (
        <EditDatasetDescription
          text={text}
          updatedAt={updatedAt}
          onSubmit={handleSaveEditForm}
          onClose={handleCloseEditForm}
        />
      ) : (
        <ViewDatasetDescription text={text} onOpenEdit={handleOpenEditForm} />
      )}
    </div>
  )
}
